import gsap from "gsap";
export function footerFunc() {
  // だるまの要素を取得
  const daruma = document.querySelector(".daruma");
  const container = document.querySelector(".site-footer__contact");

  let currentAnimation; // 現在のアニメーション
  let resizeTimer; // リサイズ用のタイマー

  // 初回アニメーション実行
  setupAnimation();

  // **リサイズ時の遅延処理（200ms待ってから発火）**
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer); // すでにタイマーがあればクリア
    resizeTimer = setTimeout(() => {
      setupAnimation();
    }, 200);
  });

  // アニメーション設定
  function setupAnimation() {
    if (currentAnimation) currentAnimation.kill(); // 既存のアニメーションを停止
    const isPC = window.matchMedia("(min-width: 750px)").matches;
    currentAnimation = isPC ? animateDarumaPC() : animateDarumaSP();
  }

  // ====== PC用アニメーション ======
  /** 右端まで転がるアニメーション
   * x: 移動距離（右端まで）
   * rotation: 回転数です。360度が1回転です。
   * duration: アニメーション時間
   * ease: イージング関数
   *
   */
  function animateDarumaPC() {
    const containerWidth = container.offsetWidth;
    const darumaWidth = daruma.offsetWidth;
    const flyDistance = containerWidth - darumaWidth - 20;

    const tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 1,
    });

    tl.set(daruma, { x: 0, y: 0, rotation: 0 });

    tl.to(daruma, { y: -50, duration: 0.4, ease: "power2.out" }).to(daruma, { y: 0, duration: 0.3, ease: "bounce.out" }).to(daruma, { y: -30, duration: 0.3, ease: "power2.out" }).to(daruma, { y: 0, duration: 0.2, ease: "bounce.out" });

    // PC版の移動 & 回転
    tl.to(daruma, { x: flyDistance * -0.2, rotation: "-=720", duration: 2, ease: "power2.out" })
      .to(daruma, { x: flyDistance * -0.4, rotation: "-=1080", duration: 2, ease: "bounce.out" })
      .to(daruma, { x: flyDistance * -0.6, rotation: "-=720", duration: 2, ease: "power2.out" })
      .to(daruma, { x: flyDistance * -0.95, rotation: "-=1800", duration: 4 });

    // PC版の戻り
    tl.to(daruma, { x: 0, rotation: "+=1800", duration: 3, ease: "bounce.out" });

    return tl;
  }

  // ====== SP用アニメーション ======
  function animateDarumaSP() {
    const containerWidth = container.offsetWidth;
    const darumaWidth = daruma.offsetWidth;
    const flyDistance = containerWidth - darumaWidth - 10; // SPでは少し小さめ

    const tl = gsap.timeline({
      repeat: -1,
      repeatDelay: 1,
    });

    tl.set(daruma, { x: 0, y: 0, rotation: 0 });

    tl.to(daruma, { y: -40, duration: 0.3, ease: "power2.out" }).to(daruma, { y: 0, duration: 0.2, ease: "bounce.out" }).to(daruma, { y: -20, duration: 0.3, ease: "power2.out" }).to(daruma, { y: 0, duration: 0.2, ease: "bounce.out" });

    // SP版の移動 & 回転（PCより少し軽め）
    tl.to(daruma, { x: flyDistance * -0.2, rotation: "-=540", duration: 1.5, ease: "power2.out" })
      .to(daruma, { x: flyDistance * -0.6, rotation: "-=900", duration: 2, ease: "bounce.out" })
      .to(daruma, { x: flyDistance * -0.95, rotation: "-=1440", duration: 3 });

    // SP版の戻り
    tl.to(daruma, { x: 0, rotation: "+=1440", duration: 2.5, ease: "bounce.out" });

    return tl;
  }
}
